import ReactSelect from 'components/form-elements/select/ReactSelect'
import {useState, useEffect} from 'react'
import { GrClose } from 'react-icons/gr'
import {BsSearch} from 'react-icons/bs'
import {useRequest} from 'hooks/useRequest'
import auth from 'utils/Auth'
import images from 'assets/images/images'
import { useTranslation } from 'react-i18next'
import {BiMinus, BiPlus} from 'react-icons/bi'
import {dataLayerPush} from 'utils/Datalayer'
import {useSelector} from 'react-redux'

const PaymentAddBasketDrawer = ({setIsOpenDrawer, setProductStage, setProductCount, setSelectedProduct, isOpenDrawer}) => {
  const headers = {
    restaurantId: auth.getUserChoises()?.restaurantId,
    deliveryType: auth.getUserChoises()?.deliveryType,
    neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
    regionId: auth.getUserChoises()?.regionId,
  }
  const { userInfo } = useSelector(state => state.general)
  const { t } = useTranslation()
    const [request] = useRequest()
    const [categories, setCategories] = useState([])
    const [products, setProducts] = useState([])
    const [filters, setFilters] = useState({
      categoryId:null,
      search:''
    })
    useEffect(() => {
      request('/Catalog/Categories',{
        method:'GET',
        headers
      }).then(res => {
        if (res.data.ok) {
          setCategories(res.data.result.map(category => ({label:category.name, value:category.id})))
        }
      })
     return () => {
      setFilters({
        categoryId:null,
        search:''
      })
     }
    },[])
    useEffect(() => {
      if (!isOpenDrawer) {
        setFilters({
          categoryId:null,
          search:''
        })
      }
    }, [isOpenDrawer])
    useEffect(() => {
      request('/Catalog/Products',{
        method:'GET',
        headers,
        params:{...filters}
      }).then(res => {
        if (res.data.ok) {
          if (filters.search) {
            dataLayerPush({
              event:"search",
              search_term:filters.search,
              component:"search box",
              user_id:userInfo?.userId
            })
          }
          setProducts(res.data.result.items.map(i => ({...i,quantity:1})))
        }
      })
    },[filters])
   const selectProduct = (product) => {
    setProductCount(product.quantity ? product.quantity : 1)
    setSelectedProduct({id:product.id, item:null})
    setProductStage(2)
   }
  return (
    <div className='paymentAddBasketDrawer'>
          <div onClick={() => setIsOpenDrawer(false)} className='paymentAddBasketDrawer-close'>
            <GrClose size={30}/>
          </div>
          <div className='paymentAddBasketDrawer-title'>{t('quickSelect')}</div>

          <div className='paymentAddBasketDrawer-select'>
            {/* <label htmlFor="">Kategori</label> */}
            <ReactSelect value={categories?.find(c => c.value == filters?.categoryId)? categories?.find(c => c.value == filters?.categoryId) : null} isSearchable isClearable handleChange={(e) => setFilters(prev => ({...prev, categoryId: e?.value ? e.value : null}))} labelText = {t('category')} className={"paymentLeftDrawerSelect"} placeholder={t('all')} options={categories}/>
          </div>
         
          <div className='paymentAddBasketDrawer-input'>
           <label htmlFor="">{t('search')}</label>
           <div className='paymentAddBasketDrawer-input-search'>
             <BsSearch/>
             <input type="text" value={filters.search} onChange={(e) => setFilters(prev => ({...prev, search:e.target.value}))} placeholder={t('searchFoodPlaceholder')} />
           </div>
          </div>

          <div className='paymentAddBasketDrawer-basket'> 
          {
            products?.map(product => (
              <div key={product.id} className='paymentAddBasketDrawer-basket-container'>
              <div className='paymentAddBasketDrawer-basket-container-top'>
              <div className='paymentAddBasketDrawer-basket-container-top-left'>
              <div className='incdecrement sm'>
                    <BiMinus onClick={() => setProducts(prev => ([...prev.map(p => {
                    if (p.id == product.id && p.quantity >1) {
                      return {...p,quantity:p.quantity - 1}
                    } else {
                      return p
                    }
                  })]))} size={16}/>  
                    <div className='body-m'>{product?.quantity || 1}</div>
                    <BiPlus onClick={() => setProducts(prev => ([...prev.map(p => {
                    if (p.id == product.id) {
                      return {...p,quantity:p.quantity +1}
                    } else {
                      return p
                    }
                  })]))} size={16}/>
                </div>
                <div className='paymentAddBasketDrawer-basket-container-top-left-text'>
                    <div className='paymentAddBasketDrawer-basket-container-top-left-text-title'>{product.name}</div>  
                    <div className='paymentAddBasketDrawer-basket-container-top-left-text-description'>{product?.price ? product?.price.toFixed(2) + " TL" : ""}</div>  
                </div>
              </div>
                <div className='paymentAddBasketDrawer-basket-container-top-right'>
                  <img src={product.productImages[0]} alt="" />
                  <img src={images.plus} alt="" onClick={()=> selectProduct(product)}/>
                </div>
              </div>
              
            </div>
            ))
          }
        </div>
    </div>
  )
}

export default PaymentAddBasketDrawer